import { lazy } from 'react';
import MainLayout from 'layout/MainLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import DashboardDoctorPage from 'views/dashboard/DoctorDashboard';

const DashboardPage = Loadable(lazy(() => import('views/dashboard')));
const PatientsPage = Loadable(lazy(() => import('views/patients')));
const PatientsProfilePage = Loadable(lazy(() => import('views/patients/PatientProfile')));
const DentalPatientsPage = Loadable(lazy(() => import('views/patients/DentalPatientsProfile')));
const OpticalPatientsPage = Loadable(lazy(() => import('views/patients/OpticalPatientsProfile')));
const CalendarPage = Loadable(lazy(() => import('views/calendar')));
const AppointmentPage = Loadable(lazy(() => import('views/appointments')));
const AddPatientPage = Loadable(lazy(() => import('views/patients/AddPatient')));
const DoctorsPage = Loadable(lazy(() => import('views/doctors')));
const DoctorProfilePage = Loadable(lazy(() => import('views/doctors/DoctorProfile')));
const AppointmentsDetailsPage = Loadable(lazy(() => import('views/appointments/AppointmentsDetails')));
const MyProfile = Loadable(lazy(() => import('views/me/Profile')));
const EditPatientPage = Loadable(lazy(() => import('views/patients/EditPatient')));
const ServicesPage = Loadable(lazy(() => import('views/services')));
const ServiceProfilePage = Loadable(lazy(() => import('views/services/ServicesProfile')));
const AddServicePage = Loadable(lazy(() => import('views/services/AddServices')));
const EditServicePage = Loadable(lazy(() => import('views/services/EditServices')));

const DoctorRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/dashboard',
            element: <DashboardDoctorPage />
        },
        {
            path: '/patients',
            element: <PatientsPage />
        },
        {
            path: '/patient/profile/:id',
            element: <PatientsProfilePage />
        },
        {
            path: '/patient/profile-info/:id',
            element: <DentalPatientsPage />
        },
        {
            path: '/patient/profile-optical/:id',
            element: <OpticalPatientsPage />
        },
        {
            path: '/patient/create',
            element: <AddPatientPage />
        },
        {
            path: '/patient/edit/:id',
            element: <EditPatientPage />
        },
        {
            path: '/calendar',
            element: <CalendarPage />
        },
        {
            path: '/appointments',
            element: <AppointmentPage />
        },
        {
            path: '/appointment/profile/:id',
            element: <AppointmentsDetailsPage />
        },
        {
            path: '/services',
            element: <ServicesPage />
        },
        {
            path: '/service/profile/:id',
            element: <ServiceProfilePage />
        },
        {
            path: '/service/create',
            element: <AddServicePage />
        },
        {
            path: '/service/edit/:id',
            element: <EditServicePage />
        },
        {
            path: 'patients/add-patient',
            element: <AddPatientPage />
        },
        {
            path: '/doctors',
            element: <DoctorsPage />
        },
        {
            path: '/doctor-profile/:id',
            element: <DoctorProfilePage />
        },
        {
            path: '/profile/:id',
            element: <MyProfile />
        }
    ]
};

export default DoctorRoutes;
